// @avantia common-code

interface Address {
  county: string;
  house: string;
  locality: string;
  postcode?: string;
  street: string;
}

export function createAddress({ county, house, locality, postcode, street }: Address): string {
  const firstSeparator = house && street ? ' ' : '';
  const secondSeparator = locality || county ? ', ' : '';
  const thirdSeparator = locality && county ? ', ' : '';
  const postcodePart = postcode && ` ${postcode}`;
  return `${house || ''}${firstSeparator}${street}${secondSeparator}${locality || ''}${thirdSeparator}${county || ''}${
    postcodePart || ''
  }`;
}
